import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppCommunicationService {
  constructor() {}

  private readonly toggleVisibilitySubject = new Subject<void>();
  private readonly toggleTagVisibilitySubject = new Subject<void>();
  private readonly displayOpenFilterButtonSubject = new Subject<boolean>();

  executeToggleVisibility$ = this.toggleVisibilitySubject.asObservable();
  executeToggleTagVisibility$ = this.toggleTagVisibilitySubject.asObservable();
  executedisplayOpenFilterButton$ =
    this.displayOpenFilterButtonSubject.asObservable();

  toggleVisibility() {
    this.toggleVisibilitySubject.next();
  }

  toggleTagVisibility() {
    this.toggleTagVisibilitySubject.next();
  }

  displayOpenFilterButton(value: boolean) {
    this.displayOpenFilterButtonSubject.next(value);
  }
}
